export default __webpack_public_path__ + "static/media/ranbir.9a297b20.jpg";